import axios from 'axios';

// import {createStore} from 'vuex';

const state = {};
const getters = {};
const mutations = {};
const actions = {
    default_credentials: async ({ commit }) => {
        return await axios
            .get(`/default_credentials`)
            .then((resp) => {
                return resp;
            })
            .catch((error) => {
                return error.response;
            });
    },

    releases: async ({ commit }, getData) => {
        return await axios
            .post('/releases', getData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then((resp) => {
                return resp;
            })
            .catch((error) => {
                return error.response;
            });
    },
    getReleases: async ({ commit, dispatch }, getData) => {
        return await axios
            .get(`/releases?query=${getData.query}&page=${getData.page}&per_page=${getData.limit}&direction=${getData.direction}&sort_by=${getData.orderBy}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
    },
    updateReleases: async ({ commit, dispatch }, getData) => {
        return await axios
            .put(`/releases/${getData.id}`, getData)
            .then((res) => {
                return res;
            })
            .catch((error) => {
                return error.response;
            });
    },
    editReleases: async ({ commit }, getData) => {
        return await axios
            .get(`/releases/${getData.id}`)
            .then((res) => {
                return res;
            })
            .catch((error) => {
                return error.response;
            });
    },
    deleteReleases: async ({ commit }, id) => {
        return await axios
            .delete(`/releases/${id}`)
            .then((resp) => {
                return resp;
            })
            .catch((error) => {
                return error.response;
            });
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
